query ViewerCanvases($first: Int!, $after: String) {
  viewer {
    canvases(first: $first, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          identifier
          title
          sharedAt
          advisor {
            name
          }
        }
      }
    }
  }
}
